<ng-container *ngIf="!!get">
    <tt-card>
        <tt-tabs ttRememberId="w_orderhead.gb_orderhead_main_production_sub" [(ttSelectedId)]="get.gb_orderhead_main_production_sub" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="POS" ttLabel="gb_orderhead_main_production_sub_pos"></tt-tab>
            <tt-tab ttId="POW" ttLabel="gb_orderhead_main_production_sub_pow"></tt-tab>
            <tt-tab ttId="OLM" ttLabel="gb_orderhead_main_production_sub_olm"></tt-tab>
        </tt-tabs>
    </tt-card>
    <div [hidden]="get.gb_orderhead_main_production_sub !== 'POS'">
        <tt-grid *ngIf="!!posGrid" [(ttOptions)]="posGrid" ttRowSelection (ttOnRowSelected)="onPoSelected($event)"></tt-grid>
        <tt-grid *ngIf="!!poPowStatusGrid" [(ttOptions)]="poPowStatusGrid"></tt-grid>
    </div>
    <tt-grid [hidden]="get.gb_orderhead_main_production_sub !== 'POW'" *ngIf="!!powStatusGrid" [(ttOptions)]="powStatusGrid"></tt-grid>
    <tt-grid [hidden]="get.gb_orderhead_main_production_sub !== 'OLM'" *ngIf="!!olmGrid" [(ttOptions)]="olmGrid"></tt-grid>
</ng-container>
